
import structuredDataJob from "@/mixins/structuredDataJob"
import breadcrumb from "@/mixins/breadcrumb"

import dates from "@/mixins/dates"
import jobInterest from "@/mixins/job/jobInterest"
import JobPagePraktikum from "@/components/job/jobpage/JobPagePraktikum"

import { mdiCloudUpload } from "@mdi/js"
import { getJobBySlug } from "@/services/v2/job.service"

export default {
    name: "JobPage",
    layout: "modern",
    components: {
        JobPagePraktikum,
        Modal: () => import("@/components/base/modal/Modal"),
        ChatContainer: () => import("@/components/chat/ChatContainer"),
        ChatForm: () => import("@/components/application/interest/ChatForm"),
        ChatFormSuccess: () => import("@/components/chat/ChatFormSuccess"),
    },
    mixins: [breadcrumb, structuredDataJob, dates, jobInterest],
    meta: {
        toolbar: {
            hidden: true,
            hideBottomNav: true,
            detailType: "job",
        },
        likeable: true,
        shareable: true,
        hideBackBtn: true,
        hideBottomNav: true,
        footer: {
            hidden: true,
            bottomPadding: 92,
        },
        survey: {
            hidden: true,
        },
    },
    async asyncData({ route, error, $api }) {
        const slug = route.params.jobSlug
        let job = null
        try {
            job = await $api.run(getJobBySlug, slug).request
        } catch (e) {
            console.error(e)
        }
        if (!job || !job?.traineeship_data?.is_active) {
            error({
                statusCode: 404,
                message:
                    "Die Stelle wurde nicht gefunden oder ist leider nicht mehr verfügbar.",
            })
        }

        return {
            displayedJob: job,
            jobLoaded: true,
        }
    },
    icons: {
        mdiCloudUpload,
    },
    data: () => ({
        displayedJob: null,
        showChatForm: false,
        sendInterestOnCreated: false,
        sendMessageOnCreated: false,
        recommendations: null,
        recommendationsRoute: null,
        isSending: false,
        firstname: "",
        lastname: "",
        isInterested: false,
        dates: [],
        showChatModal: false,
        alreadyRequested: false,
        apprenticeshipYear: null,
    }),
    computed: {
        isSelfJob() {
            if (!this.$can.business() || !this.displayedJob) return false
            return (
                this.displayedJob.business.slug ===
                this.$auth.user.business.slug
            )
        },
        jobPageV3() {
            if (Number(this.displayedJob?.version) !== 3) {
                this.$sentry.captureMessage(
                    `Job ${this.displayedJob?.id} has no version 3`
                )
            }
            return true
        },
    },
    mounted() {
        if (Object.keys(this.$route.query).length !== 0) {
            if (!this.$route.query.ref) {
                this.$router.replace({ query: null })
            }
        }
    },
    head() {
        const job = this.displayedJob
        if (!job) return
        return {
            title: this.getMetaTitle(job),
            meta: this.getMetaTags(job),
            __dangerouslyDisableSanitizers: ["script"],
            script: this.getScript(job),
        }
    },
}
